import { type FC, useState } from "react";
import { PopUp } from "@root/shared/components/PopUp";
import { Icon } from "@root/shared/components/Icon";
import { Button } from "@root/shared/components/Button";
import { TextButton } from "@root/shared/components/TextButton";
import { LazyLoadImage } from "@root/shared/components/LazyLoadImage";
import { navigateTo } from "@root/shared/utils/navigateTo";
import * as styles from "./styles.css";
import { useBannerCookies } from "./useBannerCookies";

type Props = {
  isBiyo: boolean;
};

export const WebToAppPopUp: FC<Props> = ({ isBiyo }) => {
  const [isShow, setIsShow] = useState(true);

  const { setBannerAndPopupCookies } = useBannerCookies();

  const APP_DOMAIN_SUFFIX = isBiyo ? "" : "-kaigo";
  const APP_DOWNLOAD_URL = `https://relax-job${APP_DOMAIN_SUFFIX}.onelink.me/bIVn?af_xp=custom&pid=rejob_site&c=SearchResult__WebToApp_ForSP`;

  const handleClickOpenAppButton = () => {
    navigateTo(APP_DOWNLOAD_URL);
    setBannerAndPopupCookies();
    setIsShow(false);
  };

  const handleClickWebUseButton = () => {
    setBannerAndPopupCookies();
    setIsShow(false);
  };

  return (
    <PopUp isShow={isShow}>
      <div className={styles.wrapper}>
        <div className={styles.logoWrapper}>
          <LazyLoadImage
            src="/images/global/img_rejob_logo_bg_white.svg"
            alt="app logo"
            height={64}
            width={64}
          />
        </div>
        <b className={styles.title}>アプリでもっと求人が見つかる！</b>
        <ul>
          <li className={styles.li}>
            <Icon name="done" />
            今までの行動から、最適な求人をピックアップ
          </li>
          <li className={styles.li}>
            <Icon name="done" />
            比較できて選択肢が広がる
          </li>
        </ul>
        <Button
          size="large"
          theme="primary"
          className={styles.button}
          onClick={handleClickOpenAppButton}
          data-ga-action="search_result__webtoapp_banner"
        >
          アプリで開く
        </Button>
        <TextButton
          size="large"
          isBold
          className={styles.textButton}
          onClick={handleClickWebUseButton}
          data-ga-action="search_result__webtoapp_banner_decline"
        >
          引き続きWeb版を使う
        </TextButton>
      </div>
    </PopUp>
  );
};
